import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import Start from "./start.js";
import "./index.css";
import App from "./app.js";
import Info from "./info.js";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback="loading">
    <Router>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/play" element={<App />} />
        <Route path="/info" element={<Info />} />
        {/* if wrong path redirect to the main page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  </Suspense>
);
